import type { PlacementLocation } from '@post-office/message-template-contracts/placement-v2';

type PlacementMessageErrorParams = PlacementLocation & { message?: string; error?: Error };

export class PlacementMessageError extends Error {
	placementId?: string;
	messageTemplateId?: string;
	stageName?: string;
	placementLevel?: PlacementLocation['placementLevel'];

	constructor(params: PlacementMessageErrorParams) {
		super(params.message ?? params.error?.message ?? 'unknown placement message error');
		this.name = params.error?.name ?? 'PlacementMessageError';
		this.messageTemplateId = params.messageTemplateId;
		this.placementId = params.placementId;
		this.placementLevel = params.placementLevel;
		this.stageName = params.stageName;
		this.cause = params.error?.cause;
		this.stack = params.error?.stack;
	}
}

export const createPlacementMessageError = (error: unknown): PlacementMessageError => {
	if (error instanceof PlacementMessageError) {
		return error;
	}

	if (error instanceof Error) {
		return new PlacementMessageError({ error });
	}

	return new PlacementMessageError({});
};
